import React, { Component } from 'react';
import { inject } from 'mobx-react';

import { localizable } from 'components/Localization';
import dynamicImport from 'components/dynamicImport';

const Page = dynamicImport({
  component: '/containers/Sale/SaleEditSection/Page2',
});

@inject('app')
@localizable
class Page2 extends Component {
  render() {
    return <Page {...this.props} />;
  }
}

export default Page2;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleEditSection/Page2.jsx